<template>
  <div class="menu-btn-wrap text-white flex items-center justify-center cursor-pointer px-2 text-12" :class="type">
    <template v-if="type === 'ghost'">
      <component :is="icon + 'Svg'"></component>
      <span class="ml-10px">
        <slot />
      </span>
    </template>
    <template v-else-if="type === 'plain'">
      <slot name="icon">
        <component :is="icon + 'Svg'" class="svg-icon" />
      </slot>
      <span>
        <slot></slot>
      </span>
      <el-tooltip v-if="helpText" effect="dark" :content="helpText" placement="top" popper-class="help-popper">
        <help-svg class="svg-icon ml-2" />
      </el-tooltip>
    </template>
    <template v-if="type === 'ghost-copy'">
      <component :is="icon + 'Svg'" class="svg-icon"></component>
      <span>
        <slot />
      </span>
      <el-tooltip v-if="helpText" effect="dark" placement="top" popper-class="help-popper" :content="helpText">
        <help-svg class="svg-icon ml-2" />
      </el-tooltip>
    </template>
  </div>
</template>

<script>
import deleteSvg from '~/assets/svg/icon/delete.svg'
import removeSvg from '~/assets/svg/icon/iconDelete.svg'
import addSvg from '~/assets/svg/icon/iconUpload.svg'
import copySvg from '~/assets/svg/icon/copy.svg'
import helpSvg from '~/assets/svg/icon/help.svg'
import addGreenSvg from '~/assets/svg/icon/add-green.svg'
export default {
  components: {
    deleteSvg,
    removeSvg,
    copySvg,
    helpSvg,
    addGreenSvg,
    addSvg
  },
  props: {
    type: {
      type: String,
      default: 'plain'
    },
    helpText: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
    }
  }
}
</script>

<style lang="less">
.help-popper.is-dark {
  background: rgba(30, 30, 35, 0.95) !important;
  backdrop-filter: blur(20px);
  border: 1px solid rgba(255, 255, 255, 0.1) !important;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.4) !important;
  border-radius: 8px !important;
  opacity: 1 !important;
  
  .popper__arrow {
    display: none;
  }
}

.menu-btn-wrap {
  color: rgba(255, 255, 255, 0.7);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  font-weight: 500;
  
  .svg-icon {
    fill: currentColor;
    margin-right: 8px;
    transition: transform 0.3s ease;
  }
  
  &.ghost, &.ghost-copy {
    padding: 8px 16px;
    border: 1px dashed rgba(255, 255, 255, 0.2);
    border-radius: 8px;
    background: rgba(255, 255, 255, 0.02);
    height: 36px;
    
    &:hover {
      background: rgba(255, 255, 255, 0.05);
      border-color: var(--primary-color);
      color: var(--primary-color);
      transform: translateY(-1px);
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
      
      .svg-icon {
        transform: scale(1.1);
      }
    }
    
    &:active {
      transform: translateY(0);
      background: rgba(255, 255, 255, 0.08);
    }
  }
  
  &.plain {
    border-radius: 8px;
    height: 36px;
    padding: 0 12px;
    background: rgba(255, 255, 255, 0.05);
    border: 1px solid rgba(255, 255, 255, 0.1);
    
    &:hover {
      background: rgba(255, 255, 255, 0.08);
      border-color: rgba(255, 255, 255, 0.2);
      color: white;
      transform: translateY(-1px);
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    }
    
    &:active {
      transform: translateY(0);
      background: rgba(255, 255, 255, 0.1);
    }
  }
}
</style>
